<script setup lang="ts">
withDefaults(defineProps<{
  title?: string
  text: string
  action?: string
}>(), {
  title: 'Что-то пошло не так',
  action: 'Попробовать ещё раз',
})

const emit = defineEmits<{
  retry: []
}>()
</script>

<template>
  <section class="error-state surface-card">
    <span class="error-state__icon" aria-hidden="true">!</span>
    <div>
      <h2>{{ title }}</h2>
      <p>{{ text }}</p>
      <button v-if="action" type="button" class="button button--secondary" @click="emit('retry')">
        {{ action }}
      </button>
    </div>
  </section>
</template>
